import React from "react";

const CertificationCard = ({ image, title, i }) => {
  return (
    <div className="p-4 rounded-lg bg-slate-50">
      <h2 className="py-4 text-center font-semibold text-lg">{title}</h2>
      <img src={image} className="w-full h-96 object-cover" />
    </div>
  );
};

export default CertificationCard;
